import axios from "axios";

export function getResponseMessage(
  result: unknown,
  defaultMessage = "Something went wrong.",
): string {
  if (axios.isAxiosError(result)) {
    if (typeof result.response?.data?.data === "string") {
      return result.response?.data?.data;
    }
  }

  if (result instanceof Error) {
    return result.message;
  }

  if (
    result instanceof Object &&
    "data" in result &&
    result.data instanceof Object &&
    "original" in result.data &&
    result.data.original instanceof Object &&
    "data" in result.data.original
  ) {
    if (typeof result.data.original.data === "string") {
      return result.data.original.data;
    }
  }

  if (
    result instanceof Object &&
    "data" in result &&
    result.data instanceof Object &&
    "original" in result.data &&
    result.data.original instanceof Object &&
    "message" in result.data.original
  ) {
    if (Array.isArray(result.data.original.message)) {
      return result.data.original.message.join(". ");
    }

    if (typeof result.data.original.message === "string") {
      return result.data.original.message;
    }
  }

  return defaultMessage;
}
